import { library, config } from '@fortawesome/fontawesome-svg-core'
// icons
import * as l from '@fortawesome/pro-light-svg-icons'
import * as s from '@fortawesome/pro-solid-svg-icons'

config.autoAddCss = false

export function setup() {
  library.add(
    s.faCircleEnvelope,
    l.faCircleEnvelope,
    l.faPartyHorn,
    s.faPartyHorn,
    s.faChevronDown,
    s.faChevronRight,
    s.faChevronLeft,
    l.faTreeChristmas,
    s.faTreeChristmas,
    s.faCopy,
    l.faCopy,
    l.faArrowLeft,
    l.faArrowRight,
    l.faBars,
    l.faBell,
    l.faCheck,
    l.faCheckCircle,
    l.faCircle,
    l.faClock,
    l.faCog,
    l.faDollarSign,
    l.faDownload,
    l.faEllipsisH,
    l.faGear,
    l.faHome,
    l.faInfoCircle,
    l.faMapMarkerAlt,
    l.faMinus,
    l.faNewspaper,
    l.faPencil,
    l.faPennant,
    l.faClockThree,
    l.faHandsHoldingHeart,
    l.faPlus,
    l.faSitemap,
    l.faTimes,
    l.faUser,
    l.faXmarkLarge,
    l.faQuestion,
    s.faArrowLeft,
    s.faArrowRight,
    s.faBars,
    s.faBell,
    s.faCheck,
    s.faCheckCircle,
    s.faCircle,
    s.faCircleExclamation,
    s.faCircleInfo,
    s.faCircleX,
    s.faClock,
    s.faCog,
    s.faDownload,
    s.faEllipsisH,
    s.faGear,
    s.faHome,
    s.faMapMarkerAlt,
    s.faMinus,
    s.faNewspaper,
    s.faPennant,
    s.faHandsHoldingHeart,
    s.faPlus,
    s.faSitemap,
    s.faTimes,
    s.faTriangleExclamation,
    s.faUser,
    s.faClockThree,
    s.faXmarkLarge,
    s.faQuestion
  )
}
